import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { PagePending } from './-components/page-pending';
import { PageSeo } from './-components/page-seo';
import { slugs } from './partner-ngos.meta';

export const Route = createFileRoute('/new/partner-ngos')({
	component: Component,
});

function Component() {
	const { t } = useLingui();
	return (
		<>
			{/* `noindex` while this is still a "coming soon" placeholder: the slugs and the hreflang set are
			    already right, so publishing it is a matter of deleting this flag. */}
			<PageSeo
				slugs={slugs}
				title={t`Partner NGOs - Worldcoo`}
				description={t`The social entities we work with to turn microdonations into funded projects.`}
				noindex
			/>
			<PagePending title={t`Partner NGOs`} />
		</>
	);
}
